module.exports = __webpack_public_path__ + "media/images/expo-b1921872.png";